import { render, staticRenderFns } from "./customerService-stat.vue?vue&type=template&id=1aaeb710&scoped=true"
import script from "./customerService-stat.vue?vue&type=script&lang=js"
export * from "./customerService-stat.vue?vue&type=script&lang=js"
import style0 from "./customerService-stat.vue?vue&type=style&index=0&id=1aaeb710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaeb710",
  null
  
)

export default component.exports